/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable arrow-spacing */
import { Button, TextField } from '@material-ui/core';
import React, { useState, useContext } from 'react';
import { validatePassword } from '../../utils';
import LoadingView from '../Loader/LoadingView';
import { changePasword } from '../../actions/userActions';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { PayloadContext } from '../../context';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';

function ChangePassword()
{
	const history = useHistory();

	const [ currentPassword, setCurrentPassword ] = useState('');
	const [ newPassword, setNewPassword ] = useState('');
	const [ confirmPassword, setConfirmPassword ] = useState('');
	const [ loading, setLoading ] = useState(false);
	const { getPayload } = useContext(PayloadContext);
	const [ currentPasswordShow, setCurrentPasswordShow ] = useState(false);
	const [ newPasswordShow, setNewPasswordShow ] = useState(false);
	const [ confirmPasswordShow, setConfirmPasswordShow ] = useState(false);

	const changePassword =(e)=>
	{
		e.preventDefault();
		if (currentPassword === '')
		{
			toast.error('Please enter current password');
		}
		if (newPassword === '')
		{
			toast.error('Please enter new password');
		}
		else if (!validatePassword(newPassword))
		{
			toast.error('Password should be eight characters long and combination one uppercase, one lowercase, one digit and one special character');
		}
		else if (newPassword === currentPassword)
		{
			toast.error('New password should not match with current password');
		}
		if (confirmPassword === '')
		{
			toast.error('Please enter confirm password');
		}
		else if (newPassword !== confirmPassword)
		{
			toast.error('Confirm password should match the new password');
		}
		else if (!loading)
		{
			setLoading(true);
			// eslint-disable-next-line no-console
			// console.log('currentPassword, newPassword', currentPassword, newPassword);
			const body = {
				currentPassword : currentPassword,
				newPassword     : newPassword
			};

			changePasword(body).then((res) =>
			{
				// eslint-disable-next-line no-console
				// console.log('res =====', res);
				if (res && res.data && res.data.success)
				{
					toast.success('Updated successfully');
					setLoading(false);
					localStorage.removeItem('userAuthToken');
					getPayload();
					history.push('/');
				}
				else
				{
					setLoading(false);
					toast.error(res.data.msg);
				}
			})
				.catch((err) =>
				{
				// eslint-disable-next-line quotes, no-console
					console.log('err ==== ', err);
					toast.error('Please try again');
					setLoading(false);
				});
		}

	};
	const onChangePassword = (event) =>
	{
		if (event.target.name === 'currentPassword')
		{
		  setCurrentPassword(event.target.value);
		}
		if (event.target.name === 'newPassword')
		{
		  setNewPassword(event.target.value);
		}
		if (event.target.name === 'confirmPassword')
		{
		  setConfirmPassword(event.target.value);
		}
	  };

	return (
		<div className='flexCol pdngSM '>
			{loading && <LoadingView />}
			<div className='flexMinWidthCol fullWidth'>
				<div className='position-relative'>
					<TextField
						variant='standard'
						label='Current Password'
						id='currentPassword'
						type={currentPasswordShow?'text':'password'}
						name='currentPassword' value={currentPassword}
						onChange={onChangePassword}
						fullWidth
					/>
					<span className='password-eye-icon' onClick={() => setCurrentPasswordShow(!currentPasswordShow)}>
						{currentPasswordShow?<VisibilityOffOutlinedIcon/>:<VisibilityOutlinedIcon/>}
					</span>
				</div>
				<div className='position-relative'>
					<TextField
						variant='standard'
						label='New Password'
						id='newPassword'
						type={newPasswordShow?'text':'password'}
						name='newPassword' value={newPassword} onChange={onChangePassword}
						fullWidth
					/>
					<span className='password-eye-icon' onClick={() => setNewPasswordShow(!newPasswordShow)}>
						{newPasswordShow?<VisibilityOffOutlinedIcon/>:<VisibilityOutlinedIcon/>}
					</span>
				</div>
				<div className='position-relative'>
					<TextField
						variant='standard'
						label='Confirm Password'
						id='duration'
						type={confirmPasswordShow?'text':'password'}
						name='confirmPassword' value={confirmPassword} onChange={onChangePassword}
						fullWidth
					/>
					<span className='password-eye-icon' onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}>
						{confirmPasswordShow?<VisibilityOffOutlinedIcon/>:<VisibilityOutlinedIcon/>}
					</span>
				</div>
			</div>
			<div className='flexAutoCol alignEnd fullWidth pdngSM'>
				<Button disableElevation size='small' variant='contained' color='primary' onClick={changePassword}>Submit</Button>
			</div>
		</div>
	);
}

export default ChangePassword;
